import * as React from "react";
import Page from "view/page/Page";
import Stateless from "component/Stateless";
import MessageView from "../component/layout/box/MessageView";
import { Color } from "bambu";
import language from "../data/source/language/language";
import Objects, { Props } from "wasabi-common/lib/types/Objects";

export default class NetworkUnreachable extends Stateless<{}> {
  public static messages = {
    header: "Network Unreachable",
    title: "Error",
    message: "Please check your internet connection",
  };

  public render(): JSX.Element {
    const messages = NetworkUnreachable.getMessages();
    return (
      <Page hasBox={false} header={messages.header}>
        <MessageView color={Color.danger} header={messages.title}>
          {messages.message}
        </MessageView>
      </Page>
    );
  }

  public static getMessages() {
    const error: Props<any> = (language.get("network_error") || {}) as Props<any>;
    return Objects.mergeDefaults(NetworkUnreachable.messages, error);
  }
}
